import Hero from '../components/sections/Hero';
import Features from '../components/sections/Features';
import AppPreview from '../components/sections/AppPreview';
import ServicePreview from '../components/sections/ServicePreview';

function Home() {
  return (
    <>
      <Hero />
      <Features />
      <AppPreview />
      <ServicePreview />

    </>
  );
}

export default Home;
